/**
 * This custom hook provides the functionality to retrieve users to be shown in the UI.
 */

import {useContext, useEffect, useState} from "react";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";
import {useSnackbar} from "notistack";
import {useIntl} from "react-intl";

const useLoadVideo = (key) => {
    const [video, setVideo] = useState()
    const [loading, setLoading] = useState(true)

    const {signedInUser} = useContext(FirebaseAuthContext);
    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    // Retrieving the fresh video data
    const fetchVideoData = async () => {
        const idToken = await signedInUser.getIdToken()

        return fetch('/reg-main/videos/' + key + '?idToken=' + idToken)
            .then(async (data) => {
                // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
                if (data.status !== 200) {
                    throw new Error((await data.json()).status)
                }

                const videoJson = await data.json();
                setVideo(videoJson)

                return videoJson
            })
            .catch((error) => {
                enqueueSnackbar(
                    intl.formatMessage({
                        id: 'app.videos.messages.load.video.error',
                        defaultMessage: 'Something went wrong while loading the video: {error}'
                    }, {error: error.message}), {
                        variant: 'error',
                        preventDuplicate: true,
                        autoHideDuration: 5000
                    });
            })
            .finally(() => {
                setLoading(false)
            })
    }

    // Fetch initial video data (i.e. initialization of the video state)
    useEffect(() => {
        let interval

        fetchVideoData()
            .then((video) => {

                // Start the period checking for an updated transcoding status in case the video is not yet transcoded at loading time
                if (video && !video.vimeo.transcoded) {
                    interval = setInterval(async () => {
                        const video = await fetchVideoData()

                        if (video && video.vimeo.transcoded) {
                            clearInterval(interval)
                        }
                    }, 10000);
                }
            })

        return () => clearInterval(interval);
    }, [])

    return {
        loading,
        video
    }
}
export default useLoadVideo;